import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie, X } from "lucide-react";
import { useLang } from "../i18n/LangContext";

const KEY = "dc_cookie_consent_v1";

export function CookieBanner() {
  const { t, lang } = useLang();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem(KEY);
    if (!saved) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem(KEY, JSON.stringify({ choice: "accept_all", ts: Date.now() }));
    setVisible(false);
  };
  const essentialOnly = () => {
    localStorage.setItem(KEY, JSON.stringify({ choice: "essential_only", ts: Date.now() }));
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
          className="fixed inset-x-3 bottom-3 z-50 mx-auto max-w-3xl"
          data-testid="cookie-banner"
        >
          <div className="dc-card flex flex-col gap-4 p-5 shadow-[0_20px_60px_rgba(0,0,0,0.6)] sm:flex-row sm:items-center sm:p-6">
            <div className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-2xl bg-[#ff4458]/15 text-[#ff4458]">
              <Cookie className="h-6 w-6" />
            </div>
            <div className="flex-1 text-sm leading-relaxed text-[#a8adbd]">
              {lang === "pl" ? (
                <>
                  Używamy <b className="text-white">niezbędnych cookies</b> (logowanie, preferencje) oraz <b className="text-white">localStorage</b> (sesja, język, status cookies).
                  Nie używamy reklamowych cookies trackujących.{" "}
                  <Link to="/legal/cookies" data-testid="cookie-banner-learn-more" className="text-[#ff4458] underline hover:text-white">
                    Dowiedz się więcej
                  </Link>
                </>
              ) : (
                <>
                  We use only <b className="text-white">essential cookies</b> (login, preferences) and <b className="text-white">localStorage</b> (session, language, cookie state).
                  No tracking or ad cookies.{" "}
                  <Link to="/legal/cookies" data-testid="cookie-banner-learn-more" className="text-[#ff4458] underline hover:text-white">
                    Learn more
                  </Link>
                </>
              )}
            </div>
            <div className="flex flex-shrink-0 flex-wrap gap-2">
              <button onClick={essentialOnly} data-testid="cookie-essential-only"
                className="rounded-full border border-[#222636] bg-[#181b24] px-4 py-2 text-xs font-semibold text-[#a8adbd] hover:text-white">
                {lang === "pl" ? "Tylko niezbędne" : "Essential only"}
              </button>
              <button onClick={accept} data-testid="cookie-accept-all"
                className="rounded-full dc-gradient-bg px-4 py-2 text-xs font-semibold text-white shadow-[0_8px_20px_rgba(253,38,122,0.3)]">
                {lang === "pl" ? "Akceptuję wszystkie" : "Accept all"}
              </button>
              <button onClick={essentialOnly} aria-label="Close" className="text-[#a8adbd] hover:text-white sm:hidden">
                <X className="h-4 w-4" />
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
